import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { guaranteeItems } from "../../data/content";
export function GuaranteeSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-177" data-mp="1kb2gy3fa9p8g">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[260px_1fr]" data-id="element-178" data-mp="1fdatpmpl2ral">
        <div className="mx-auto flex h-56 w-56 flex-col items-center justify-center rounded-full bg-navy text-center text-white ring-8 ring-gold/80 md:h-64 md:w-64" data-id="element-179" data-mp="1adfy55uv5dj7">
          <ShieldCheckIcon className="h-12 w-12 text-gold" aria-hidden="true" data-id="element-180" data-mp="15gpn4wxx184n" />
          <p className="mt-2 font-serif text-6xl font-extrabold leading-none" data-id="element-181" data-mp="11djfplz2hawl">7</p>
          <p className="mt-1 text-sm font-extrabold uppercase tracking-[0.2em]" data-id="element-182" data-mp="wf887hw8vchj">Day guarantee</p>
        </div>

        <div data-id="element-183" data-mp="2vqitranstx1r">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.18em] text-brand" data-id="element-184" data-mp="2voy9qez41wi5">Try it for 7 days</p>
          <h2 id="guarantee-title" className="mt-3 font-serif text-[30px] leading-[1.12] sm:text-[44px] font-bold text-ink text-balance" data-id="element-185" data-mp="2qq3hynj60xlw">
            Explore Otoplasty Clinical Pathway System™ With a 7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg text-ink/80" data-id="element-186" data-mp="174osnbjw94lf">
            I want you to be able to explore the system and decide whether it fits the way you study. During your first seven days, you can:
          </p>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-187" data-mp="1zskq4ihaf0j9">
            {guaranteeItems.map(item => <li key={item} className="flex gap-2.5 text-base text-ink" data-id="element-188" data-mp="23tcxt7aigxdf">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-189" data-mp="1q39lp95cik1p" />
                <span data-id="element-190" data-mp="1v1uj70t7qpmg">{item}</span>
              </li>)}
          </ul>
          <p className="mt-5 text-base leading-relaxed text-ink/75" data-id="element-191" data-mp="1uzrldultjs76">
            If you decide the system isn't right for your educational needs, you can request a refund within the seven-day guarantee
            period according to the purchase terms.
          </p>
          <p className="mt-3 font-semibold text-ink" data-id="element-192" data-mp="2xdvodsjl2sqe">My goal is to give you the opportunity to evaluate the material for yourself.</p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-5xl" data-id="element-193" data-mp="2nfokobeb276c">
        <CtaButton label="Try Otoplasty Clinical Pathway System™ for 7 days" data-id="element-194" data-mp="2ned75jv25l21" />
      </div>
    </section>;
}